import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Tab from './tab';

class SlidesTabs extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        currentPath: PropTypes.string,
        showShadow: PropTypes.bool,
        handleTabChange: PropTypes.func,
    };

    tabs = React.createRef();

    componentDidUpdate() {
        if (this.props.currentPath === 'search' && this.tabs.current) {
            this.tabs.current.scrollLeft = 200;
        } else if ((this.props.currentPath === 'sankey' || this.props.currentPath === 'header') && this.tabs.current) {
            this.tabs.current.scrollLeft = 0;
        }
    }

    render() {
        const { content, currentPath, showShadow, handleTabChange } = this.props;

        return (
            <div className={`${styles.tabs_box} ${showShadow ? styles.shadow : styles.br}`}>
                <div className={styles.tabs} ref={this.tabs}>
                    <Tab content={content} currentPath={currentPath} handleTabChange={handleTabChange} />
                </div>
                <div className={styles.mask} />
            </div>
        );
    }
}

export default SlidesTabs;
